import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import DatePickerMui from '../../../common/DatePickerMui'; // Adjust path as needed
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import DashBoardTable from '../components/Table';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { useQuery } from '../../../components/Control/useQuery';

const useStyles = makeStyles({
  container: {
    marginTop: 0,
    padding: '18.4px'
  },
  datePickerContainer: {
    display: 'flex',
    justifyContent: 'center'
  }
});

const PendingReportsTables = () => {
  const classes = useStyles();
  const urlParams = new URLSearchParams(window.location.search);
  const dateParam = urlParams.get('date');
  let initialDate;
  if (dateParam) {
    initialDate = moment(decodeURIComponent(dateParam));
  } else {
    initialDate = moment();
  }
  const [selectedDate, setSelectedDate] = useState(initialDate);
  const endpoint = useQuery('endpoint') || 'pendingReportsRoute';
  
  const handleDateChange = (date) => {
    if (date) {
      setSelectedDate(moment(date));
    }
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.datePickerContainer}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePickerMui
            label="Select Date"
            value={selectedDate ? selectedDate.toDate() : null}
            onChange={handleDateChange}
            views={['month', 'year']}
            format="MMMM yyyy"
            openTo="month"
          />
        </MuiPickersUtilsProvider>
      </Box>
      <DashBoardTable
        date={selectedDate ? selectedDate.format('YYYY-MM-DD') : ''}
        endpoint={endpoint}
        frozenColumns={1}
      />
    </Box>
  );
};

export default PendingReportsTables;